import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Grid, MenuItem, Alert } from '@mui/material';
import api from '../../api';

const LeaveUnallocationAssign = ({ empId, departments, showMsg, setActiveTab }) => {
  const [unallocForm, setUnallocForm] = useState({ 
    leave_type: 'CL', 
    reason: '', 
    assignment_type: 'ALL', 
    target_id: '' 
  });

  const handleUnallocSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...unallocForm, created_by: empId };
    if (!payload.target_id) payload.target_id = null;
    try {
      await api.post('/leave/unallocations', payload);
      showMsg("Unallocation requested successfully!");
      setUnallocForm({ leave_type: 'CL', reason: '', assignment_type: 'ALL', target_id: '' });
      setActiveTab('unalloc_history');
    } catch (err) { 
      showMsg(err.response?.data?.detail || "Failed", "error"); 
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 4, borderRadius: 2, maxWidth: 800 }}>
      <Typography variant="h6" color="error" gutterBottom sx={{ fontWeight: 'bold' }}>Empty Leave Balances (Unallocate)</Typography>
      <Alert severity="warning" sx={{ mb: 3 }}>This action will set the targeted group's balance to 0 for the selected leave type.</Alert>
      <Box component="form" onSubmit={handleUnallocSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField select fullWidth size="small" label="Leave Type to Empty" value={unallocForm.leave_type} onChange={e => setUnallocForm({...unallocForm, leave_type: e.target.value})}>
              {['CL', 'ML', 'AL', 'EL', 'NH', 'WO'].map(lt => <MenuItem key={lt} value={lt}>{lt}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField select fullWidth size="small" label="Target Group" required value={unallocForm.assignment_type} onChange={e => setUnallocForm({...unallocForm, assignment_type: e.target.value})}>
              <MenuItem value="ALL">Empty for ALL</MenuItem>
              <MenuItem value="DEPARTMENT">Empty for Department</MenuItem>
              <MenuItem value="EMPLOYEE">Empty for Employee</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth size="small" label="Reason for Unallocation" required value={unallocForm.reason} onChange={e => setUnallocForm({...unallocForm, reason: e.target.value})} />
          </Grid>
          {unallocForm.assignment_type === 'DEPARTMENT' && 
            <Grid item xs={12}>
              <TextField select fullWidth size="small" label="Select Department" required value={unallocForm.target_id} onChange={e => setUnallocForm({...unallocForm, target_id: e.target.value})}>
                {departments.map(d => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
              </TextField>
            </Grid>
          }
          {unallocForm.assignment_type === 'EMPLOYEE' && 
            <Grid item xs={12}>
              <TextField fullWidth size="small" label="Employee ID" required value={unallocForm.target_id} onChange={e => setUnallocForm({...unallocForm, target_id: e.target.value})} />
            </Grid>
          }
        </Grid>
        <Button type="submit" variant="contained" color="error">Submit Unallocation</Button>
      </Box>
    </Paper>
  );
};

export default LeaveUnallocationAssign;